/**
 * Product Description Toggle
 * Handles "See more / See less" functionality for truncated descriptions
 */

document.addEventListener('DOMContentLoaded', function() {
  const toggleButtons = document.querySelectorAll('.product__description-toggle');

  toggleButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const container = this.closest('.product__description-content');
      const preview = container.querySelector('.product__description-preview');
      const full = container.querySelector('.product__description-full');
      const moreText = this.querySelector('.toggle-more');
      const lessText = this.querySelector('.toggle-less');

      if (!preview || !full) return;

      const isExpanded = full.style.display !== 'none';

      if (isExpanded) {
        // Collapse: show preview, hide full
        preview.style.display = 'block';
        full.style.display = 'none';
        moreText.style.display = 'inline';
        lessText.style.display = 'none';
      } else {
        // Expand: hide preview, show full
        preview.style.display = 'none';
        full.style.display = 'block';
        moreText.style.display = 'none';
        lessText.style.display = 'inline';
      }
    });
  });
});
